import React, { FC } from "react";
import { UserOutlined } from "@ant-design/icons";
import { format } from "date-fns";
import { getScheduleStatusTextColor } from "../utils";
import { TaskCalendarStatus } from "../types";

interface CalendarEventContentProps {
  title: string;
  status: TaskCalendarStatus;
  start: Date | null;
  end: Date | null;
  assignee?: string;
}

export const CalendarEventContent: FC<CalendarEventContentProps> = ({
  title,
  status,
  start,
  end,
  assignee,
}) => {
  const timeRange =
    start && end
      ? `${format(start, "yyyy-MM-dd HH:mm")} - ${format(
          end,
          "yyyy-MM-dd HH:mm"
        )}`
      : "";

  const tooltip = [title, timeRange, assignee, status]
    .filter(Boolean)
    .join("\n");

  const statusTextColor = getScheduleStatusTextColor(status);

  // min-w-0 + truncate keep long titles/names inside narrow week and month
  // cells; the full text is in the tooltip.
  return (
    <div
      className={`flex flex-col w-full min-w-0 h-full overflow-hidden ${statusTextColor}`}
      title={tooltip}
    >
      <div className="truncate">
        {start && (
          <span className="mr-1 font-normal opacity-90">
            {format(start, "HH:mm")}
          </span>
        )}
        {title}
      </div>
      {assignee && (
        <div className="flex items-center gap-1 min-w-0 text-[10px] font-normal opacity-90">
          <UserOutlined className="shrink-0" />
          <span className="truncate">{assignee}</span>
        </div>
      )}
    </div>
  );
};
